import BlipChatImage from 'assets/img/channelsv3/blipchat.svg';
import EmailImage from 'assets/img/channelsv3/email.svg';
import MessengerImage from 'assets/img/channelsv3/messenger.svg';
import WorkplaceImage from 'assets/img/channelsv3/workplace.svg';
import SMSImage from 'assets/img/channelsv3/sms.svg';
import TelegramImage from 'assets/img/channelsv3/telegram.svg';

const blipChat = {
    name: 'BLiP Chat',
    imageSrc: BlipChatImage,
};

const email = {
    name: 'Email',
    imageSrc: EmailImage,
};

const messenger = {
    name: 'Facebook Messenger',
    imageSrc: MessengerImage,
};

const workplace = {
    name: 'Facebook Workplace',
    imageSrc: WorkplaceImage,
};

const sms = {
    name: 'SMS',
    imageSrc: SMSImage,
};

const telegram = {
    name: 'Telegram',
    imageSrc: TelegramImage,
};

export default {
    'text/plain': [
        blipChat,
        email,
        messenger,
        workplace,
        sms,
        telegram,
    ],
    'application/vnd.lime.media-link+json': {
        media: [blipChat, email, messenger, workplace, sms, telegram],
        'media-audio': [
            blipChat,
            email,
            messenger,
            workplace,
            sms,
            telegram,
        ],
        'media-document': [
            blipChat,
            email,
            messenger,
            workplace,
            sms,
            telegram,
        ],
        'media-video': [blipChat, email, messenger, workplace, sms, telegram],
    },
    'application/vnd.lime.location+json': [
        blipChat,
        messenger,
        workplace,
        telegram,
    ],
    'application/vnd.lime.input+json': [blipChat, messenger, workplace],
    'application/vnd.lime.document-select+json': [
        blipChat,
        messenger,
        workplace,
        telegram,
    ],
    'application/vnd.lime.collection+json': [
        blipChat,
        messenger,
        workplace,
        // telegram,
    ],
    'application/vnd.lime.select+json': [
        blipChat,
        messenger,
        workplace,
        telegram,
    ],
    'application/vnd.lime.web-link+json': [
        blipChat,
        email,
        messenger,
        workplace,
        sms,
        telegram,
    ],
    //raw content
    '': [blipChat, email, messenger, workplace, sms, telegram],
};
